import React from 'react';

function WorkspaceInvite(props) {
    return (
        <div></div>
    );
}

export default WorkspaceInvite;